import { NAME, DIALOGS } from './constants';
import { STATES } from '../../lib/constants';

export const CONFIRM = `${NAME}/CONFIRM`;
export const CONFIRM_FAILURE = `${NAME}/CONFIRM_${STATES.FAILURE}`;
export const CONFIRM_REQUEST = `${NAME}/CONFIRM_${STATES.REQUEST}`;
export const CONFIRM_SUCCESS = `${NAME}/CONFIRM_${STATES.SUCCESS}`;
export const LOAD_TERMS = `${NAME}/LOAD_TERMS`;
export const LOAD_TERMS_FAILURE = `${NAME}/LOAD_TERMS_${STATES.FAILURE}`;
export const LOAD_TERMS_REQUEST = `${NAME}/LOAD_TERMS_${STATES.REQUEST}`;
export const LOAD_TERMS_SUCCESS = `${NAME}/LOAD_TERMS_${STATES.SUCCESS}`;
export const SIGNUP = `${NAME}/SIGNUP`;
export const SIGNUP_FAILURE = `${NAME}/SIGNUP_${STATES.FAILURE}`;
export const SIGNUP_REQUEST = `${NAME}/SIGNUP_${STATES.REQUEST}`;
export const SIGNUP_SUCCESS = `${NAME}/SIGNUP_${STATES.SUCCESS}`;
export const RESET = `${NAME}/RESET`;
export const RESET_FAILURE = `${NAME}/RESET_${STATES.FAILURE}`;
export const RESET_REQUEST = `${NAME}/RESET_${STATES.REQUEST}`;
export const RESET_SUCCESS = `${NAME}/RESET_${STATES.SUCCESS}`;
export const LOGIN = `${NAME}/LOGIN`;
export const LOGIN_FAILURE = `${NAME}/LOGIN_${STATES.FAILURE}`;
export const LOGIN_REQUEST = `${NAME}/LOGIN_${STATES.REQUEST}`;
export const LOGIN_SUCCESS = `${NAME}/LOGIN_${STATES.SUCCESS}`;
export const LOGOUT = `${NAME}/LOGOUT`;
export const LOGOUT_FAILURE = `${NAME}/LOGOUT_${STATES.FAILURE}`;
export const LOGOUT_REQUEST = `${NAME}/LOGOUT_${STATES.REQUEST}`;
export const LOGOUT_SUCCESS = `${NAME}/LOGOUT_${STATES.SUCCESS}`;
export const REFRESH = `${NAME}/REFRESH`;
export const REFRESH_FAILURE = `${NAME}/REFRESH_${STATES.FAILURE}`;
export const REFRESH_REQUEST = `${NAME}/REFRESH_${STATES.REQUEST}`;
export const REFRESH_SUCCESS = `${NAME}/REFRESH_${STATES.SUCCESS}`;
export const RESTORE = `${NAME}/RESTORE`;
export const HIDE_DIALOG = `${NAME}/HIDE_DIALOG`;
export const SHOW_DIALOG = `${NAME}/SHOW_DIALOG`;
export const UPDATE_INPUT = `${NAME}/UPDATE_INPUT`;
export const SET_USER_COOKIES_DATA = `${NAME}/SET_USER_COOKIES_DATA`;
export const SAVE_UNVERIFIED_EMAIL = `${NAME}/SAVE_UNVERIFIED_EMAIL`;
export const USE_URL_PAYLOAD = `${NAME}/USE_URL_PAYLOAD`;
export const SAVE_FOLLOW_DATA = `${NAME}/SAVE_FOLLOW_DATA`;
export const SAVE_CREATE_ALERT_CLICK = `${NAME}/SAVE_CREATE_ALERT_CLICK`;

export const restore = payload => ({
  type: RESTORE,
  payload,
});

export const logout = () => ({
  type: LOGOUT,
});

export const login = (identifier, password, callback) => ({
  type: LOGIN,
  payload: { identifier, password },
  callback,
});

export const magic = identifier => ({
  type: RESET,
  payload: { identifier },
});

export const signup = () => ({
  type: SIGNUP,
});

export const loadTerms = () => ({
  type: LOAD_TERMS,
});

export const showLogin = callback => ({
  type: SHOW_DIALOG,
  payload: { type: DIALOGS.LOGIN, callback },
});

export const showMagic = () => ({
  type: SHOW_DIALOG,
  payload: { type: DIALOGS.MAGIC },
});

export const showTaken = () => ({
  type: SHOW_DIALOG,
  payload: { type: DIALOGS.TAKEN },
});

export const showCreate = () => ({
  type: SHOW_DIALOG,
  payload: { type: DIALOGS.CREATE },
});

export const showCreateTerms = () => ({
  type: SHOW_DIALOG,
  payload: { type: DIALOGS.CREATE_TERMS },
});

export const showUnverified = () => ({
  type: SHOW_DIALOG,
  payload: { type: DIALOGS.UNVERIFIED },
});

export const hideDialog = () => ({ type: HIDE_DIALOG });
export const updateValue = (key, value) => ({
  type: UPDATE_INPUT,
  payload: { key, value },
});

export const setUserCookiesData = payload => ({
  type: SET_USER_COOKIES_DATA,
  payload,
});

export const saveUnverifiedAccount = email => ({
  type: SAVE_UNVERIFIED_EMAIL,
  payload: { value: email },
});

export const useUrlPayload = payload => ({
  type: USE_URL_PAYLOAD,
  payload,
});

export const saveFollowData = id => ({
  type: SAVE_FOLLOW_DATA,
  payload: { id },
});

export const saveCreateAlertClick = () => ({
  type: SAVE_CREATE_ALERT_CLICK,
});
